/*
 * Copyright (C) 2026 Fluxer Contributors
 *
 * This file is part of Fluxer.
 *
 * Fluxer is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * Fluxer is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with Fluxer. If not, see <https://www.gnu.org/licenses/>.
 */

import {makeAutoObservable} from 'mobx';

const STORAGE_KEY = 'fluxer.startup.launchGuildId';

// Which guild to open when the app launches (null = default behavior, i.e. the Friends screen).
// Read synchronously from localStorage in the constructor so the startup redirect (RootRoutes
// homeRoute.onEnter) sees the value immediately, without waiting for async hydration.
class StartupStore {
	launchGuildId: string | null = null;

	constructor() {
		try {
			this.launchGuildId = localStorage.getItem(STORAGE_KEY) || null;
		} catch {}
		makeAutoObservable(this, {}, {autoBind: true});
	}

	setLaunchGuildId(guildId: string | null): void {
		this.launchGuildId = guildId && guildId.length > 0 ? guildId : null;
		try {
			if (this.launchGuildId) {
				localStorage.setItem(STORAGE_KEY, this.launchGuildId);
			} else {
				localStorage.removeItem(STORAGE_KEY);
			}
		} catch {}
	}
}

export default new StartupStore();
